@if (isTrainingTask$ | async) {
  <h3-training-tools></h3-training-tools>
}

<div
  class="project-steps-graphic-bar steps-agent-info"
  *ngIf="submitters$ | async"
>
  <strong>Agents:</strong>
  <h3-agents-per-step></h3-agents-per-step>
</div>
<div class="row">
  <div class="col-xs-6">
    <h3-button
      *ngIf="project.view_previous_task && previousTask?.id"
      class="workspace-button"
      [blockStyle]="true"
      (h3Click)="viewPreviousTask()"
    >
      View Previous
    </h3-button>
  </div>
</div>
<h3-rejection-reasons
  *ngIf="
    task.round > 1 &&
    project?.show_rejected_answers &&
    (isTrainingTask$ | async) === false
  "
></h3-rejection-reasons>
<h3-task-comment *ngIf="project?.show_task_comments"></h3-task-comment>
